import type { ParcoursResponse } from "../api/parcoursApi";

/**
 * A parcours is considered "past" when ALL its dates are strictly before today.
 * Parcours with no dates are NOT considered past (they're treated as upcoming drafts).
 *
 * Used to hide past parcours on the public front-office (back-office still sees them).
 */
export function isPastParcours(p: Pick<ParcoursResponse, "dates">): boolean {
  // Use each slot's END date when available so a multi-day slot only counts as past
  // after its last day.
  const effectiveEnds = (p.dates ?? [])
    .map((d) => d.endDate || d.date)
    .filter(Boolean) as string[];
  if (effectiveEnds.length === 0) return false;
  const today = new Date().toISOString().slice(0, 10);
  return effectiveEnds.every((d) => d < today);
}

export function filterUpcoming<T extends Pick<ParcoursResponse, "dates">>(items: T[]): T[] {
  return items.filter((p) => !isPastParcours(p));
}
